import * as angular from 'angular';
import * as _ from 'lodash';

import { IMailingJobService } from '../../services';
import { MailingJobDefinitionDto } from '../../models';
import { Store } from '../Store';

import * as Actions from './mailingJobs.actions';


export interface IMailingJobActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<MailingJobDefinitionDto>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<MailingJobDefinitionDto[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<MailingJobDefinitionDto[]>;
}

export class MailingJobsActionsService implements IMailingJobActionsService {
    static serviceId = 'mailingJobActionsService';
    static $inject = ['$q', 'mailingJobService'];

    constructor(
        private _$q: angular.IQService,
        private _mailingJobService: IMailingJobService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { mailingJobs } = getState();
            if (!mailingJobs.isLoading && !mailingJobs.isLoaded) {
                dispatch(Actions.loadMailingJobs());
                return this._mailingJobService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(Actions.loadMailingJobsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadMailingJobsError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<MailingJobDefinitionDto>(mailingJobs.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { mailingJobs } = getState();
            if (force || (!mailingJobs.isLoading && !mailingJobs.isLoaded)) {
                dispatch(Actions.loadMailingJobs());
                return this._mailingJobService.getAll(force)
                    .then(data => {
                        dispatch(Actions.loadMailingJobsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadMailingJobsError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<MailingJobDefinitionDto>(mailingJobs.dictionary));
            }
        };
    }

    /*addOne(target: MailingJob) {
        return this.addMany([target]);
    }

    addMany(targets: MailingJob[]) {
        return (dispatch: any, getState: () => Store) => {
            const { mailingJobs } = getState();
            if (targets && targets.length > 0) {
                dispatch(addMailingJobs(targets));
                return this._mailingJobService.addMailingJobs(targets)
                    .then(data => {
                        const result = data;
                        dispatch(addMailingJobsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: MAILINGJOBS.MAILINGJOBS_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<MailingJobDefinitionDto>(mailingJobs.dictionary));
            }
        };
    }

    updateOne(target: MailingJob) {
        return this.updateMany([target]);
    }

    updateMany(targets: MailingJob[]) {
        return (dispatch: any, getState: () => Store) => {
            const { mailingJobs } = getState();
            if (targets && targets.length > 0) {
                dispatch(updateMailingJobs(targets));
                return this._mailingJobService.updateMailingJobs(targets)
                    .then(data => {
                        const result = data;
                        dispatch(updateMailingJobsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: MAILINGJOBS.MAILINGJOBS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<MailingJobDefinitionDto>(mailingJobs.dictionary));
            }
        };
    }

    deleteOne(guid: string) {
        return this.deleteMany([guid]);
    }

    deleteMany(guids: string[]) {
        return (dispatch: any, getState: () => Store) => {
            const { mailingJobs } = getState();
            if (guids && guids.length > 0) {
                dispatch(deleteMailingJobs(guids));
                return this._mailingJobService.deleteMailingJobs(guids)
                    .then(data => {
                        const result = data;
                        dispatch(deleteMailingJobsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: MAILINGJOBS.MAILINGJOBS_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<MailingJobDefinitionDto>(mailingJobs.dictionary));
            }
        };
    }*/
}